function getColorBrightness(rgbColor) {
  var colorValues = rgbColor.match(/[\d\.]+/g).map(Number);
  return 0.2126 * (colorValues[0] / 255) + 0.7152 * (colorValues[1] / 255) + 0.0722 * (colorValues[2] / 255);
}

function isSimilarToBackground(color) {
  var backgroundColor = 'rgb(255, 255, 255)';

  var colorBrightness = getColorBrightness(color);
  var backgroundColorBrightness = getColorBrightness(backgroundColor);

  return (backgroundColorBrightness / colorBrightness) < 1.5;
}

var SwatchColors = (function() {
  function SwatchColors() {
    this.colors = {};

    this.images = {'framed-print': 'url("//www.lucypittaway.co.uk/cdn/shop/files/framed-print_120x.png?v=6337396485403179449")','framed-canvas': 'url("//www.lucypittaway.co.uk/cdn/shop/files/framed-canvas_120x.png?v=13674254342501040224")','mounted-print': 'url("//www.lucypittaway.co.uk/cdn/shop/files/mounted-print_120x.png?v=17119584078676585292")','print-only': 'url("//www.lucypittaway.co.uk/cdn/shop/files/print-only_120x.png?v=7976218825269732244")','canvas-only': 'url("//www.lucypittaway.co.uk/cdn/shop/files/canvas-only_120x.png?v=7976218825269732244")','black': 'url("//www.lucypittaway.co.uk/cdn/shop/files/Black_120x.png?v=16809074368299480486")','white': 'url("//www.lucypittaway.co.uk/cdn/shop/files/White_120x.png?v=9415197100021568527")','oak': 'url("//www.lucypittaway.co.uk/cdn/shop/files/Oak_120x.png?v=16373973984141736882")','dove-grey': 'url("//www.lucypittaway.co.uk/cdn/shop/files/Dove_Grey_120x.png?v=771137920401414375")','slate-grey': 'url("//www.lucypittaway.co.uk/cdn/shop/files/Slate_Grey_120x.png?v=18132390106166136053")','slate-bevel': 'url("//www.lucypittaway.co.uk/cdn/shop/files/Slate_Bevel_120x.png?v=11074703658455143834")','dove-grey': 'url("//www.lucypittaway.co.uk/cdn/shop/files/Dove_Grey_120x.png?v=771137920401414375")','dove-bevel': 'url("//www.lucypittaway.co.uk/cdn/shop/files/Dove_Bevel_120x.png?v=8286795979695788329")',};

    this.triggers = ['gift voucher style',];
  }

  function setSwatchColor(swatch) {
    var swatchId = swatch.getAttribute('swatch-id');

    if (Object.keys(this.colors).includes(swatchId)) {
      swatch.style.setProperty("--background-graphic", this.colors[swatchId]);

      if (isSimilarToBackground(this.colors[swatchId])) swatch.classList.add('is-similar-to-background');
      if (getColorBrightness(this.colors[swatchId]) > 0.5) {
        swatch.style.setProperty('--tick-color', '#000');
      } else {
        swatch.style.setProperty('--tick-color', '#fff');
      }
      swatch.classList.remove('is-blank');
    }

    if (Object.keys(this.images).includes(swatchId)) {
      swatch.style.setProperty("--background-graphic", this.images[swatchId]);
      swatch.classList.add('is-image');
      swatch.classList.remove('is-blank');
    }
  }
  SwatchColors.prototype.setSwatchColor = setSwatchColor;

  return SwatchColors;
}());

const Swatches = new SwatchColors();

function VariantSwatch() {
  return Reflect.construct(HTMLElement, [], this.constructor);
}

VariantSwatch.prototype = Object.create(HTMLElement.prototype);
VariantSwatch.prototype.constructor = VariantSwatch;
Object.setPrototypeOf(VariantSwatch, HTMLElement);

VariantSwatch.prototype.connectedCallback = function() {
  Swatches.setSwatchColor(this);
};
customElements.define('variant-swatch', VariantSwatch);

export default Swatches;
